import { get } from 'lodash';

import { SCOPE } from './types';

const selector = state => get(state, SCOPE);
export default selector;
